import { RootState } from "@/data/store";

import { ErrorState } from "@/data/error/errorSlice";

export function getError({ error }: RootState): ErrorState | null {
  return error;
}
